/** Admin contact shown when a member needs password help (no self-service email OTP). */

export const FORGOT_PASSWORD_ADMIN = {
  phoneDisplay: "+91 98068 63659",
  phoneTel: "+919806863659",
  email: "raipurlink@gmail.com",
  whatsappUrl: "https://wa.me/919806863659",
  location: "Raipur, Chhattisgarh, India",
};

export const FORGOT_PASSWORD_MESSAGES = {
  en: {
    title: "Forgot your password?",
    lead: "Password reset is handled by our admin team. Please contact us with your User ID (Reg ID) and registered mobile number.",
    call: "Call",
    email: "Email",
    whatsapp: "WhatsApp",
    close: "Close",
    backLogin: "Back to login",
  },
  hi: {
    title: "पासवर्ड भूल गए?",
    lead: "पासवर्ड रीसेट एडमिन द्वारा किया जाता है। कृपया अपना User ID (Reg ID) और रजिस्टर्ड मोबाइल नंबर बताकर संपर्क करें।",
    call: "कॉल",
    email: "ईमेल",
    whatsapp: "WhatsApp",
    close: "बंद करें",
    backLogin: "लॉगिन पर वापस",
  },
};
